import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment.demo';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  isLoggedIn = true;
  hasVisitedContribute = true;
  jwtAuthorizationToken: any;
  apiTimer = setInterval(() => {
    this.jwtAuthorizationToken = "" + sessionStorage.getItem('accessToken')
    if (this.jwtAuthorizationToken) {
      clearInterval(this.apiTimer);
    }
  }, 2000)





  constructor(private http: HttpClient) { }
  //Subject for BehaviorSubject
  private username$ = new BehaviorSubject(null);

  //Loacal code - uncomment this line for local code execution
  // private username$ = new BehaviorSubject("riya.mukund.fanse");

  checkRefreshTokenValidity(){
    if(!sessionStorage.getItem('loggedInAt')){
      let dateLoggeIn=new Date();
      sessionStorage.setItem('loggedInAt',dateLoggeIn.toString())
    }else{
      let storedDate= new Date(sessionStorage.getItem('loggedInAt') || '');
      // console.log(storedDate);
      let currentDate=new Date();
      // console.log(currentDate);
      let diff=Math.floor(currentDate.getTime()- storedDate.getTime())/1000/60/60;
      // console.log("diffe...",diff);
      if(diff>=23){
        sessionStorage.clear();
        window.location.reload();
      }
    }
  }

  getUsername(): Observable<any> {
    return this.username$.asObservable();
  }
  setUsername(userdata: any) {
    this.username$.next(userdata);
  }

  // API URL
  getHostURL(): string {
    return environment.apiURL;
  }
  //Portal URL
  getPortalURL(): string {
    return environment.portalURL;
  }

  //Update user details
  insertUserDetails(): Observable<any> {
    return this.http.post(this.getHostURL() + "/homePage/userdetails", {}, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  //Home page API
  getHomePagedetails(username: any): Observable<any> {
    // console.log("this.jwtAuthorizationToken service file", this.jwtAuthorizationToken);
    return this.http.post(this.getHostURL() + "/homePage/getLandingPages", { In_Username: username }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  //All assssets API
  getAllAssets(flag: number, id: any, username: any): Observable<any> {
    const input = { In_Flag: flag, In_Asset_Id: id, In_Username: username };
    return this.http.post(
      this.getHostURL() + '/assetPage/getassetdetails',
      input, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    }
    );
  }

  //Update view count API
  upateAssetViewCount(username: any, asset_id: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/assetPage/updateviewcount", { username, asset_id }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  //rating and commnetpage
  addUserRatingComment(username: any, asset_id: any, rating: any, comment: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/assetPage/ratingcomment", { username, asset_id, rating, comment }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  getRatingDetails(asset_id: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/assetPage/ratingdetails", { asset_id }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  //FAQ API
  getFaqPagedetails(): Observable<any> {
    return this.http.get(this.getHostURL() + "/faqPage/faq", {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  //Add asset into Bookmarked page
  addAssetBookmarked(is_user_bookmarked: any, asset_id: any, username: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/bookmarkPage/assetBookMarked", { is_user_bookmarked, username, asset_id }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }
  // AssetPage Filters API
  getAssetFilters(): Observable<any> {
    return this.http.get(this.getHostURL() + "/assetPage/filterdetails", {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    })
  }
  getContributionData(inFlag: any, inRoleFlag: any, inUsername: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/contributionPage/getContributions", { "In_Flag": inFlag, "In_Role_Flag": inRoleFlag, "In_Username": inUsername }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });

  }
  // Submit Contribution Form
  submitContributeAsset(assetValues: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/contributionPage/createAsset", { assetValues }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    })
  }

  uploadFile(formData: any, userName: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/contributionPage/uploadfile", formData, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    })
  }
  updateContributionStatus(statusid: any, assetid: any, username: any, comments: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/contributionPage/updateContributionStatus", { "status_id": statusid, "asset_id": assetid, "username": username, "comments": comments }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }

  deleteAsset(assetid: any): Observable<any> {
    return this.http.post(this.getHostURL() + "/contributionPage/deleteAsset", { "asset_id": assetid }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken
      }
    });
  }

  // fetch graph api token
  fetchGraphAPIAccessToken(): Observable<any> {
    return this.http.get(this.getHostURL() + "/users/fetchGraphAPIAccessToken", {

      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    });
  }
  // get User Id Suggestions
  getEnterpriseIdSuggestions(userNameinput: any, graphAPIAccessToken: any) {
    return this.http.post(this.getHostURL() + "/users/getUserEID", { "user_name": userNameinput, "GraphApiToken": graphAPIAccessToken }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken,
      }
    });
  }

  // validateUserEID
  validateUserEID(userNameinput: any, graphAPIAccessToken: any) {
    return this.http.post(this.getHostURL() + "/users/validateUserEID", { "user_name": userNameinput, "GraphApiToken": graphAPIAccessToken }, {
      headers: {
        "Cache-Control": "no-cache",
        authorization: this.jwtAuthorizationToken,
      }
    });
  }
  public sendmail(data: any): Observable<any> {
    return this.http
      .post(this.getHostURL() + "/contributionPage/sendResponseMail", data,
        {
          headers: {
            "Cache-Control": "no-cache",
            authorization: this.jwtAuthorizationToken,
          }
        }
      );
  }

  public downloadCodeRepo(data: any): Observable<any> {
    return this.http
      .post(this.getHostURL() + "/contributionPage/downloadFile", { "filePath": data },
        {
          responseType: 'blob',
          headers: {
            "Cache-Control": "no-cache",
            authorization: this.jwtAuthorizationToken,
          }
        }
      );
  }

  getMSALTokenExplicitly(): Observable<any> {
    return this.http.post(environment.authority+'/v1.0/me', ['user.read']);
  }

}




